document.addEventListener("DOMContentLoaded", function () {
  /* ---------------------------
     CONTACT POPUP FUNCTIONALITY
  --------------------------- */
  const contactPopup = document.querySelector(".hero-banner-slider__contact-popup");
  const triggerButtons = document.querySelectorAll(".hero-banner-slider__popup-btn");
  const closeButton = document.querySelector(".hero-banner-slider__contact-popup-close");

  function openPopup() {
    contactPopup.classList.add("active");
    document.body.classList.add("overflow-hidden");
  }

  function closePopup() {
    contactPopup.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }

  if (contactPopup && triggerButtons.length) {
    triggerButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        openPopup();
      });
    });

    if (closeButton) {
      closeButton.addEventListener("click", closePopup);
    }

    // Close when clicking outside popup content
    contactPopup.addEventListener("click", (e) => {
      if (e.target === contactPopup) {
        closePopup();
      }
    });
  }

  /* -----------------------------------------
     CLOSE POPUP IF POPUP LINK == NAVIGATION ID
  ----------------------------------------- */
  const navigationId = contactPopup?.dataset.navigationId; // <-- Liquid value passed here

  if (navigationId) {
    const popupLinks = document.querySelectorAll(".hero-banner-slider__contact-popup a");

    popupLinks.forEach((link) => {
      const linkHref = link.getAttribute("href");

      if (linkHref === navigationId) {
        link.addEventListener("click", () => {
          closePopup();
        });
      }
    });
  }

  /* ---------------------------
      STICKY BUTTON WRAPPER LOGIC
  --------------------------- */
 const heroSection = document.querySelector(".hero-banner-slider");
  const stickyBtnWrapper = document.querySelector(".hero-banner-slider__sticky-btn-wrapper");
  const consultationSection = document.querySelector(".clinic-consultation-form");
  const footerSection = document.querySelector(".shopify-section--footer");

  if (heroSection && stickyBtnWrapper) {
    // Sticky toggle based on hero visibility
    const observerHero = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBtnWrapper.classList.toggle("is-sticky", !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observerHero.observe(heroSection);

    // Common observer to hide sticky CTA
    const hideStickyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBtnWrapper.classList.toggle("hide-sticky", entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );

    if (consultationSection) {
      hideStickyObserver.observe(consultationSection);
    }

    if (footerSection) {
      hideStickyObserver.observe(footerSection);
    }
  }

});
